// extracted by mini-css-extract-plugin
export default {"entryLabel":"styles_entryLabel__xZ8Hx","eventImage":"styles_eventImage__z57Xj","titleEvent":"styles_titleEvent__YUA2Q","dateEvent":"styles_dateEvent__dxDvi"};